import { Table as AntdTable, TableProps as AntdTableProps } from 'antd'
import React from 'react'

export interface TableProps extends AntdTableProps<any> {}

export const Table: React.FC<TableProps> = props => <AntdTable {...props} />
